import { autoinject, transient } from "aurelia-dependency-injection";
import { RightShipDialogServiceConstants } from "../../../../../../../../constants/basics/rightship-dialog.constants";
import { VetClientModel } from "../../../../../../../../models/vetting/vetting.models";
import { AttachmentClientService } from "../../../../../../../../services/attachment/attachments-client.service";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { NotificationClientService, NotificationType } from "../../../../../../../../services/basics/notification-client.service";
import { QueriesClientService } from "../../../../../../../../services/queries/queries-client.services";
import { AttachmentsHelper } from "../../../../../../../../utilities/attachments-helper";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";

@autoinject
@transient()
export class Sire {

    numberOfDaysBeforeExpiry: number = 3;
    isLoading: boolean = false;
    items: any[] = [];
    vet: VetClientModel;
    vetTask: { vetTaskId: number };

    constructor(private queriesClientService: QueriesClientService, private dialogClientService: DialogClientService,
        private attachmentClientService: AttachmentClientService, private notificationService: NotificationClientService,
        private configService: ConfigService) { }

    activate(model: { vet: VetClientModel, vetTask: { vetTaskId: number } }) {
        this.isLoading = true;
        this.vet = model.vet;
        this.vetTask = model.vetTask;
        this.queriesClientService.getData(`odata/VetTaskSires?$filter=vetTaskId eq ${model.vetTask.vetTaskId}`).then(x => {
            this.items = x && x.value ? x.value.filter(x => this.daysFromNow(x) <= this.numberOfDaysBeforeExpiry) : [];
            this.isLoading = false;
        });

    }

    view(id: number, vesselName: string, filter: string = null) {
        this.dialogClientService.show(RightShipDialogServiceConstants.URLs.VetSireReportDialog, { id, vesselName, filter }, true, false, false, "right");
    }

    viewHighlight(id: number, vesselName: string, filter: string = null) {
        this.dialogClientService.show(RightShipDialogServiceConstants.URLs.VetSireReportDialogHighlight, { id, vesselName, filter }, true, false, false, "right");
    }

    daysFromNow(item) {
        const now = new Date();
        const date2 = new Date(item.emailReceivedDate);
        const difference = now.getTime() - date2.getTime();
        const days = Math.ceil(difference / (1000 * 3600 * 24));

        return this.configService.config.settings.showSireTableInVetCriteria ? 0 : days;
    }

    public open(item, fileName: string) {
        const path = `sire/${item.vettingSireReportId}/${fileName}`;
        this.attachmentClientService.getSharedAccessSignatureTokenFromPath(path, fileName).then(sasToken => {
            let url = AttachmentsHelper.getUrl(path);
            if (sasToken) {
                url += ((sasToken.startsWith("?") ? "" : "?") + sasToken);
            }
            const link = document.createElement('a');
            link.setAttribute('target', "_blank");
            link.setAttribute('href', url);
            link.setAttribute('download', fileName);
            link.click();
            link.remove();
        }).catch(() => {
            this.notificationService.show("Error", "You do not have enough permissions to open/download this file", NotificationType.Error);
        });
    }
}